import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "admin-section" }
const _hoisted_2 = {
  target: "_blank",
  href: "https://memories.gallery/hw-transcoding/#va-api"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NcNoteCard = _resolveComponent("NcNoteCard")!
  const _component_NcCheckboxRadioSwitch = _resolveComponent("NcCheckboxRadioSwitch")!
  const _component_NcTextField = _resolveComponent("NcTextField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", null, _toDisplayString(_ctx.$options.title), 1),
    _createElementVNode("p", null, [
      _createTextVNode(_toDisplayString(_ctx.t('memories', 'You must first make sure the correct drivers are installed before configuring acceleration.')) + " ", 1),
      _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'Make sure you test hardware acceleration with various options after enabling.')) + " ", 1),
      _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'Do not enable multiple types of hardware acceleration simultaneously.')) + " ", 1),
      _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
      _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.t(
          'memories',
          'Intel processors supporting QuickSync Video (QSV) as well as some AMD GPUs can be used for transcoding using VA-API acceleration.',
        )) + " ", 1),
      _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'For more details on driver installation, check the documentation:')) + " ", 1),
      _createElementVNode("a", _hoisted_2, _toDisplayString(_ctx.t('memories', 'External Link')), 1),
      (_ctx.status && _ctx.enableTranscoding && !_ctx.config['memories.vod.external'] && _ctx.config['memories.vod.vaapi'])
        ? (_openBlock(), _createBlock(_component_NcNoteCard, {
            key: 0,
            type: _ctx.vaapiStatusType
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.vaapiStatusText), 1)
            ]),
            _: 1
          }, 8, ["type"]))
        : _createCommentVNode("", true),
      _createVNode(_component_NcCheckboxRadioSwitch, {
        disabled: !_ctx.enableTranscoding,
        modelValue: _ctx.config['memories.vod.vaapi'],
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.config['memories.vod.vaapi']) = $event)),
          _cache[1] || (_cache[1] = ($event: any) => (_ctx.update('memories.vod.vaapi')))
        ],
        type: "switch"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('memories', 'Enable acceleration with VA-API')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "modelValue"]),
      _createVNode(_component_NcCheckboxRadioSwitch, {
        disabled: !_ctx.enableTranscoding || !_ctx.config['memories.vod.vaapi'],
        modelValue: _ctx.config['memories.vod.vaapi.low_power'],
        "onUpdate:modelValue": [
          _cache[2] || (_cache[2] = ($event: any) => ((_ctx.config['memories.vod.vaapi.low_power']) = $event)),
          _cache[3] || (_cache[3] = ($event: any) => (_ctx.update('memories.vod.vaapi.low_power')))
        ],
        type: "switch"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('memories', 'Enable low-power mode (QSV only)')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "modelValue"]),
      _createVNode(_component_NcTextField, {
        disabled: !_ctx.enableTranscoding || !_ctx.config['memories.vod.vaapi'],
        label: _ctx.t('memories', 'VA-API device path'),
        "label-visible": true,
        "model-value": _ctx.config['memories.vod.vaapi.device'],
        onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.update('memories.vod.vaapi.device', $event.target.value)))
      }, null, 8, ["disabled", "label", "model-value"]),
      _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'NVIDIA GPUs can be used for transcoding using the NVENC encoder with the proper drivers.')) + " ", 1),
      _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.t(
          'memories',
          'Depending on the versions of the installed SDK and ffmpeg, you need to specify the scaler to use',
        )) + " ", 1),
      (_ctx.status && _ctx.enableTranscoding && !_ctx.config['memories.vod.external'] && _ctx.config['memories.vod.nvenc'])
        ? (_openBlock(), _createBlock(_component_NcNoteCard, {
            key: 1,
            type: "warning"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('memories', 'No automated tests are available for NVIDIA acceleration.')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_NcCheckboxRadioSwitch, {
        disabled: !_ctx.enableTranscoding,
        modelValue: _ctx.config['memories.vod.nvenc'],
        "onUpdate:modelValue": [
          _cache[5] || (_cache[5] = ($event: any) => ((_ctx.config['memories.vod.nvenc']) = $event)),
          _cache[6] || (_cache[6] = ($event: any) => (_ctx.update('memories.vod.nvenc')))
        ],
        type: "switch"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('memories', 'Enable acceleration with NVENC')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "modelValue"]),
      _createVNode(_component_NcCheckboxRadioSwitch, {
        disabled: !_ctx.enableTranscoding || !_ctx.config['memories.vod.nvenc'],
        modelValue: _ctx.config['memories.vod.nvenc.temporal_aq'],
        "onUpdate:modelValue": [
          _cache[7] || (_cache[7] = ($event: any) => ((_ctx.config['memories.vod.nvenc.temporal_aq']) = $event)),
          _cache[8] || (_cache[8] = ($event: any) => (_ctx.update('memories.vod.nvenc.temporal_aq')))
        ],
        type: "switch"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('memories', 'Enable NVENC Temporal AQ')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "modelValue"]),
      _createVNode(_component_NcCheckboxRadioSwitch, {
        disabled: !_ctx.enableTranscoding || !_ctx.config['memories.vod.nvenc'],
        modelValue: _ctx.config['memories.vod.nvenc.scale'],
        "onUpdate:modelValue": [
          _cache[9] || (_cache[9] = ($event: any) => ((_ctx.config['memories.vod.nvenc.scale']) = $event)),
          _cache[10] || (_cache[10] = ($event: any) => (_ctx.update('memories.vod.nvenc.scale')))
        ],
        value: "cuda",
        name: "nvence_scaler_radio",
        type: "radio",
        class: "m-radio"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('memories', 'CUDA scaler')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "modelValue"]),
      _createVNode(_component_NcCheckboxRadioSwitch, {
        disabled: !_ctx.enableTranscoding || !_ctx.config['memories.vod.nvenc'],
        modelValue: _ctx.config['memories.vod.nvenc.scale'],
        "onUpdate:modelValue": [
          _cache[11] || (_cache[11] = ($event: any) => ((_ctx.config['memories.vod.nvenc.scale']) = $event)),
          _cache[12] || (_cache[12] = ($event: any) => (_ctx.update('memories.vod.nvenc.scale')))
        ],
        value: "npp",
        name: "nvence_scaler_radio",
        type: "radio",
        class: "m-radio"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('memories', 'NPP scaler')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "modelValue"]),
      _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.t(
          'memories',
          'Due to a bug in certain hardware drivers, videos may appear in incorrect orientations when streaming. This can be resolved in some cases by rotating the video on the accelerator.',
        )) + " " + _toDisplayString(_ctx.t(
          'memories',
          'Some drivers (e.g. AMD and older Intel) do not support hardware accelerated rotation. You can attempt to force software-based transpose in this case.',
        )) + " ", 1),
      _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("b", null, _toDisplayString(_ctx.t('memories', 'Try this option only if you have incorrectly oriented videos during playback.')), 1),
      _createVNode(_component_NcCheckboxRadioSwitch, {
        disabled: !_ctx.enableTranscoding,
        modelValue: _ctx.config['memories.vod.use_transpose'],
        "onUpdate:modelValue": [
          _cache[13] || (_cache[13] = ($event: any) => ((_ctx.config['memories.vod.use_transpose']) = $event)),
          _cache[14] || (_cache[14] = ($event: any) => (_ctx.update('memories.vod.use_transpose')))
        ],
        type: "switch"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('memories', 'Enable streaming transpose workaround')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "modelValue"]),
      _createVNode(_component_NcCheckboxRadioSwitch, {
        disabled: !_ctx.enableTranscoding || !_ctx.config['memories.vod.use_transpose'],
        modelValue: _ctx.config['memories.vod.use_transpose.force_sw'],
        "onUpdate:modelValue": [
          _cache[15] || (_cache[15] = ($event: any) => ((_ctx.config['memories.vod.use_transpose.force_sw']) = $event)),
          _cache[16] || (_cache[16] = ($event: any) => (_ctx.update('memories.vod.use_transpose.force_sw')))
        ],
        type: "switch"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('memories', 'Force transpose in software')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "modelValue"]),
      _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'Some NVENC devices have issues with force_key_frames.')) + " ", 1),
      _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("b", null, _toDisplayString(_ctx.t('memories', 'Try this option only if you use NVENC and have issues with video playback.')), 1),
      _createVNode(_component_NcCheckboxRadioSwitch, {
        disabled: !_ctx.enableTranscoding,
        modelValue: _ctx.config['memories.vod.use_gop_size'],
        "onUpdate:modelValue": [
          _cache[17] || (_cache[17] = ($event: any) => ((_ctx.config['memories.vod.use_gop_size']) = $event)),
          _cache[18] || (_cache[18] = ($event: any) => (_ctx.update('memories.vod.use_gop_size')))
        ],
        type: "switch"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('memories', 'Enable streaming GOP size workaround')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "modelValue"])
    ])
  ]))
}